enum PlannerView {
  DAY = 1,
  WEEK = 2,
}

export default PlannerView;